import accessibleAutocomplete from 'accessible-autocomplete';

const getSuggestionLabel = (item) => {
  if (typeof item === 'string') {
    return item;
  }

  return item?.label || '';
};

const fetchSuggestions = (query, done) => {
  fetch(search_autocomplete.url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
    body: new URLSearchParams({
      action: search_autocomplete.action,
      searchString: query,
      nonce: search_autocomplete.nonce,
    }),
  })
    .then((res) => res.json())
    .then((data) => done(data.results || []))
    .catch((err) => {
      console.error(err);
      done([]);
    });
};

document.querySelectorAll('.autocompleteSearch').forEach((el) => {
  const { id, placeholder, name = 's', defaultValue = '' } = el.dataset;
  if (!id) {
    console.warn('Autocomplete element missing data-id', el);
    return;
  }

  accessibleAutocomplete({
    element: el,
    id,
    name,
    placeholder,
    defaultValue,
    minLength: 2,
    displayMenu: 'overlay',
    templates: {
      inputValue: (item) => getSuggestionLabel(item),
      suggestion: (item) => getSuggestionLabel(item),
    },
    source(query, done) {
      if (!query || query.length < 2) {
        done([]);
        return;
      }
      fetchSuggestions(query, done);
    },
    onConfirm(selection) {
      if (selection && typeof selection === 'object' && selection.url) {
        window.location.assign(selection.url);
      }
    },
  });

  // Keep explicit, visible label linkage for generated autocomplete input.
  const generatedInput = el.querySelector('input.autocomplete__input');
  const matchingLabel = document.getElementById(`${id}-label`)
    || document.querySelector(`label[for="${id}"]`);

  if (generatedInput) {
    generatedInput.id = id;
    if (matchingLabel) {
      if (!matchingLabel.id) {
        matchingLabel.id = `${id}-label`;
      }
      generatedInput.setAttribute('aria-labelledby', matchingLabel.id);
    }

    generatedInput.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') {
        return;
      }

      const hasSelectedSuggestion = el.querySelector('.autocomplete__option--focused');
      if (hasSelectedSuggestion) {
        return;
      }

      const form = generatedInput.closest('form');
      if (form) {
        event.preventDefault();
        form.requestSubmit();
      }
    });
  }

  document.addEventListener('click', (event) => {
    if (el.contains(event.target)) {
      return;
    }

    const input = el.querySelector('input.autocomplete__input');
    const menu = el.querySelector('.autocomplete__menu');

    if (input) {
      input.setAttribute('aria-expanded', 'false');
    }

    if (menu) {
      menu.classList.remove('autocomplete__menu--visible');
    }
  });
});
